module.exports = __webpack_public_path__ + "static/home-1-d-829cca1a345044019d440d2aa56883b5.mp4";